<template>
<div>
  <van-field 
    center
    :name="schema.name + '_' +schema.uniqid"
    :label="schema.label" 
    :placeholder="schema.placeholder" 
    :value="schema.value"
    :required="schema.required === true" 
    :rules="[{ required: schema.required === true ,message:'请选择'+schema.label}]"
  >
    <template slot="button">
      <van-button size="small" type="primary" icon="map-marked" @click="onLocationPicker"  native-type="button">位置</van-button>
    </template>
  </van-field>

  <van-popup v-model="showLocationPicker" @close="onCloseLocationPicker" :style="{ height: '90%',width:'90%' }" close-icon-position="bottom-left" close-icon="close" closeable round>
    <div style="width:100%;height:100%;">
    <iframe id="mapPage" style="width:100%;height:100%;" frameborder=0
        src="https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=BMWBZ-GXD6W-WQYRC-R7ZEC-SONP7-E7FXO&referer=2weima.com">
    </iframe>
    </div>
  </van-popup>
</div>
</template>

<script>
// import { Notify } from 'vant';

export default {
  name: 'mapMarked',
  props: {
    schema: {
      'type':Object,
      default:{},
      required:true
    },
    pluginIndex:{
      type:Number,
      default:0
    }
  },
  data:function(){
    return {
      showLocationPicker:false
    }
  },
  methods:{
    //地图选点组件
    messageHandle:function(event){
       // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
          var loc = event.data;
          if (loc && loc.module == 'locationPicker') {//防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
            // console.log('location',this.pluginIndex, loc);
            // cityname: "清远市"
            // latlng: Object
            //   lat: 23.69795
            //   lng: 113.06269
            // module: "locationPicker"
            // poiaddress: "清远市"
            // poiname: "我的位置"

            var _value = loc.poiname;
            if(loc.poiname == "我的位置"){
              if(!loc.poiaddress || loc.poiaddress =="")
              {
                 _value = loc.poiname;
              }else{
                _value = loc.poiaddress;
              }
            }

            
            this.schema.value = _value;
            this.schema.marked = loc;
            this.showLocationPicker = false;

            // console.log(this.schema);
          }
    },
    //监听地图选点
    onLocationPicker:function(){
      this.showLocationPicker = true;
      // this.pluginIndex = index;
      // console.log( this.pluginIndex );
      window.addEventListener('message', this.messageHandle, false);
    },
    //取消监听
    onCloseLocationPicker:function(){
       window.removeEventListener('message', this.messageHandle, false);
    }
  }
}
</script>

<style>

</style>